export default "__VITE_ASSET__CQOw2NdO__";